import { render, staticRenderFns } from "./BaseNumberField.vue?vue&type=template&id=56bea966"
import script from "./BaseNumberField.vue?vue&type=script&lang=js"
export * from "./BaseNumberField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports